import { AbstractPmsApiService } from "./abstract.service";
import { EventAdditionalOption } from "../models";

/**
 * @class EventAdditionalOptionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<EventAdditionalOption>}
 */
export class EventAdditionalOptionPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/event-additional(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {EventAdditionalOption}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new EventAdditionalOption(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<EventAdditionalOption>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});

        const ignoreLB = params.hasOwnProperty('searchValue');

        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {EventAdditionalOption} event
     * @param {Property} property
     * @returns {Promise.<EventAdditionalOption>}
     */
    create(event, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, event.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {EventAdditionalOption} event
     * @returns {Promise.<EventAdditionalOption>}
     */
    update(event) {
        
        const url = this.url({
            propertyId: event.property.id,
            id:         event.id
        });
        
        return this.http
                   .put(url, event.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {EventAdditionalOption} event
     * @returns {Promise.<boolean>}
     */
    delete(event) {
        
        const url = this.url({
            propertyId: event.property.id,
            id:         event.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    freeRooms(property, from, to, exclude = null, accommodationsFilter = []) {
        
        const url = this.url({propertyId: property.id});

        return this.http
            .post(url + '/free-rooms', {
                'from': from,
                'to': to,
                'exclude': exclude,
                'accommodationsFilter': accommodationsFilter,
            }, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
    
    autoAssignAll(property, accIds) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url + '/assign-all', {'accommodations': accIds}, {
                       headers: this.authHeaders
                   })
                   .then()
                   .catch(this.getErrorHandler());
    }
    
    assignAccommodation(property, reservationAccommodationId, accommodationTypeId, roomId) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url + '/assign', {
                       'accommodation_id': reservationAccommodationId,
                       'accommodation_type_id': accommodationTypeId,
                       'room_id': roomId
                    }, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    unassignedAccommodations(params, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
            .get(url + '/free-reservation/' + params.date_booked_start + '/' + params.date_booked_end, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/event-additional-option.service.js